<template>
    <a-cascader
      v-model:value="address"
      :field-names="{ label: 'name', value: 'id', children: 'children' }"
      :options="cityList"
      :disabled='disabled'
      :placeholder="placeholder"
      changeOnSelect
      @change="onChangeAddress"
    />
</template>
<script>
  import { ref, reactive, toRefs,watchEffect } from 'vue';
  import { message } from 'ant-design-vue';
  import { getArea } from "@/api/public";
  export default {
    name:'selectCity',
    components: {},
    props: {
      addressData:{
        type:Array
      },
      disabled:{
        type:Boolean
      },
      placeholder:{
          type:String,
           default(){ 
            return "请选择收货地址"
          }
      }
    },
    setup(props,{ emit }) {
      const state = reactive({
        cityList:[],
        address:[],
        disabled:false
      });
      //获取省市区
      const getAreaList = async () => {
        let result = await getArea().then(res => res)
        state.cityList = result.data
      }
      getAreaList();
      //选择省市区
      const onChangeAddress = (e,s) => {
        emit("citychange", e,s);
        emit('update:value', e);
      }
      watchEffect(() => {
        state.address = props.addressData || []
        state.disabled = props.disabled || false
      });
      return {
        ...toRefs(state),
        getAreaList,
        onChangeAddress
      }
    }
  }
</script>
